export default __webpack_public_path__ + "static/media/lesd.9527823e.jpg";